import { render, staticRenderFns } from "./SalesBlock.vue?vue&type=template&id=0e457ba7&"
import script from "./SalesBlock.vue?vue&type=script&lang=js&"
export * from "./SalesBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports